module.exports = __webpack_public_path__ + "img/CT-znak.9245e1c.svg";